<template>
  <footer class="footer">
    <div class="container" :class="{ 'footer-rwd': this.$route.name === 'CourseLesson' }">
      <div class="row">
        <div class="col-12">
          <div class="footer-info">
            <span>{{ copy.phone }}</span>
            <span>{{ copy.hours }}</span>
            <span>{{ copy.email }}</span>
          </div>
          {{ copy.copyright }}
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      footerCopy: {
        tw: {
          phone: '服務專線: (02)2660-0608 分機 207',
          hours: '服務時間: 週一至週五 09:00~18:00',
          email: '服務信箱: mary_wang@liveabc.com',
          copyright: 'Copyright Hebron Soft Limited. All Rights Reserved.'
        },
        en: {
          phone: 'Service Hotline: +886-2-2660-0608 ext. 207',
          hours: 'Service Hours: Monday to Friday, 09:00-18:00',
          email: 'Service Email: mary_wang@liveabc.com',
          copyright: 'Copyright Hebron Soft Limited. All Rights Reserved.'
        }
      }
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n ? this.$i18n.locale : 'tw'
    },
    copy () {
      return this.footerCopy[this.currentLocale] || this.footerCopy.tw
    }
  },
  methods: {}
}
</script>

<style scoped lang="scss">
@import "../assets/styles/color.scss";
@import "../assets/styles/custom.scss";

.footer {
  padding: calc(4vh - 12px);
  background-color: black;
  min-height: 8vh;
  color: $white-color;
  position: relative;
  text-align: center;
}

.footer-info {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 4px 12px;
  margin-bottom: 4px;
}

@media all and (max-width: 768px) {
  .footer-info {
    flex-direction: column;
  }
}
</style>
